import React, { useEffect, useState } from 'react'

import { debounce } from '../../../lib/utils/debounce'

type ScrollShadowState = 'none' | 'left' | 'right' | 'both'
const debounceMs = 100

export const useShadowState = (
  scrollRef: React.RefObject<HTMLElement>
): {
  shadowState: ScrollShadowState
  updateScrollState: () => void
} => {
  const [shadowState, setShadowState] = useState<ScrollShadowState>('none')

  const checkScrollState = (left: number, width: number) => {
    if (width === 0) return 'none'
    if (left === 0) return 'right'

    // left is a negative value when in RTL
    if (Math.abs(left) >= width) return 'left'

    return 'both'
  }

  const updateScrollState = () => {
    if (!scrollRef.current) return
    const el = scrollRef.current
    setShadowState(checkScrollState(el.scrollLeft, el.scrollWidth - el.clientWidth))
  }

  useEffect(() => {
    scrollRef.current?.addEventListener('scroll', updateScrollState)
    // TODO: Fix this auto-generated suppression.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => scrollRef.current?.removeEventListener('scroll', updateScrollState)
    // TODO: Fix this auto-generated suppression.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const handler = debounce(updateScrollState, debounceMs)
    window.addEventListener('resize', handler)
    return () => window.removeEventListener('resize', handler)
    // TODO: Fix this auto-generated suppression.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    updateScrollState()
    // TODO: Fix this auto-generated suppression.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    shadowState,
    updateScrollState,
  }
}
